import classNames from 'classnames';
interface Props {
  children: React.ReactNode;
  className?: string;
  percent: number;
  isLoading?: boolean;
}
export function ProgressBar({
  children,
  className,
  percent,
  isLoading = false
}: Props) {
  if (isLoading) return <div className={classNames(className, 'h-9 w-full animate-pulse rounded-md bg-gray-200 lg:h-10')}></div>;
  return <div className={classNames('flex w-full flex-col gap-3 text-xs lg:gap-5 lg:text-sm', className)} data-sentry-component="ProgressBar" data-sentry-source-file="progress-bar.tsx">
            <div className='h-1 w-full rounded-md bg-rose-200'>
                <div className='h-1 rounded-md bg-pink-500 transition-all duration-500' style={{
        width: `${percent}%`
      }}></div>
            </div>
            {children}
        </div>;
}